import { HasuraRoles } from '../';

export const hasAdminAccess = (roles: HasuraRoles[] | null) =>
  roles && roles.includes('admin');
